<div>
  <ng-content select="[loading-banner]" />
  <div class="title-flex">
    <h3 class="title-with-icon">
      <svg-icon src="assets/images/icons/port.svg" class="purple"></svg-icon>
      <ng-content select="[heading]" />
    </h3>
    <ng-content select="[action-button]" />
  </div>

  @if (hasServices()) {
    <div class="card card--no-padding tabs">
      <tabbed-detail-navigation [tabs]="tabs()" [(activeTabIndex)]="activeTabIndex" />

      <div class="tabs__content">
        <div class="tabs__grid">
          <ng-content select="[tab-content]" />
        </div>
      </div>
    </div>
  } @else {
    <div class="card card--no-padding">
      <empty-state
        [title]="
          'ServiceElement.EmptyState.Title' | translate: { product: ('ServiceElement.NoConnectedNetworks' | translate) }
        "
        [icons]="['ip', 'l2vpn']"
      ></empty-state>
    </div>
  }
</div>
